<ng-container *ngIf="!loading; else loader">
  <div class="mbs-GSW"
       [class.agent-installation]="(selectedView === view.Computers) && (currentStep === 'agentInstallation')">
    <ng-container *ngTemplateOutlet="header"></ng-container>
    <ng-container *ngTemplateOutlet="closeButton"></ng-container>
    <ng-container *ngTemplateOutlet="background"></ng-container>
    <ng-container *ngTemplateOutlet="footer"></ng-container>

    <div class="mx-auto d-flex flex-column justify-content-center h-100">
      <ng-container [ngSwitch]="selectedView">
        <ng-container *ngSwitchCase="null">
          <div class="text-center">
            <h1>{{ 'wizards:onboarding.main_title' | i18next: { format: 'title' } }}</h1>

            <p class="pre-wrap m-0 mbs-GSW_description">{{ 'wizards:onboarding.welcome_to_trial' | i18next }}</p>
          </div>

          <div class="row justify-content-center pt-5">
            <div *ngFor="let tile of tilesConfig"
                 class="col-4">
              <mbs-tile [tileTemplate]="tileTemplate"
                        [disabled]="loading"
                        [selectable]="true"
                        (click)="onViewChoiceButtonClick(tile.id)">
                <ng-template #tileTemplate>
                  <div class="d-flex flex-column align-items-center p-5">
                    <img [src]="tile.icon"
                         [alt]="tile.title"
                         class="mb-4">
                    <span class="font-weight-semibold mb-1 pre-wrap text-center">{{ tile.title }}</span>
                    <span *ngIf="tile.description"
                          class="text-md text-gray-600">{{ tile.description }}</span>
                  </div>
                </ng-template>
              </mbs-tile>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="view.Computers">
          <mbs-onboarding-wizard-computers-view [class]="'mbs-GSW_computers'"
                                                [mode]="mode"
                                                [back]="back"
                                                [next]="next"
                                                (updateBackButton)="updateButton('back', $event)"
                                                (updateNextButton)="updateButton('next', $event)"
                                                (currentStepChange)="currentStep = $event"
                                                (finish)="finish($event)"></mbs-onboarding-wizard-computers-view>
        </ng-container>

        <ng-container *ngSwitchCase="view.HyperV">
          <mbs-onboarding-wizard-hyper-v-view [class]="'mbs-GSW_hyperv'"
                                              [back]="back"
                                              [next]="next"
                                              (updateBackButton)="updateButton('back', $event)"
                                              (updateNextButton)="updateButton('next', $event)"
                                              (finish)="finish($event)"></mbs-onboarding-wizard-hyper-v-view>
        </ng-container>

        <ng-container *ngSwitchCase="view.Apps">
          <mbs-onboarding-apps-view [class]="'mbs-GSW_apps'"
                                    [mode]="mode"
                                    [step]="step"
                                    [back]="back"
                                    [next]="next"
                                    (updateBackButton)="updateButton('back', $event)"
                                    (updateNextButton)="updateButton('next', $event)"
                                    (finish)="finish($event)"></mbs-onboarding-apps-view>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loader>
  <mbs-loader></mbs-loader>
</ng-template>

<ng-template #header>
  <div class="mbs-GSW_header row justify-content-between">
    <div class="mbs-GSW_msp-logo-container col-auto">
      <img class="mbs-GSW_msp-logo pl-3"
           [src]="'assets/logo-msp360.svg'">
    </div>
  </div>
</ng-template>

<ng-template #closeButton>
  <div class="mbs-GSW_close-button row justify-content-between">
    <div class="col-auto">
      <mbs-button [isCtrl]="true"
                  type="dark"
                  class="pr-3"
                  [icon]="'ico ico-Close'"
                  (click)="skip(finishPath.Computers)"></mbs-button>
    </div>
  </div>
</ng-template>

<ng-template #background>
  <div *ngIf="!selectedView"
       class="mbs-GSW_background">
    <span class="mbs-GSW_background-image mbs-GSW_background-image-1 mbs-agent mbs-agent_backup"></span>
    <span class="mbs-GSW_background-image mbs-GSW_background-image-2 mbs-agent mbs-agent_backup"></span>
    <span class="mbs-GSW_background-image mbs-GSW_background-image-3 mbs-agent mbs-agent_backup"></span>
  </div>
</ng-template>

<ng-template #footer>
  <div class="mbs-GSW_footer row justify-content-between">
    <div class="col-4 text-left">
      <mbs-button *ngIf="selectedView && backButtonState.visible"
                  class="pl-3"
                  [disabled]="!!backButtonState.disable"
                  (click)="moveBack()">
        <span *ngIf="!backButtonState.text">{{ 'wizards:onboarding.buttons.back' | i18next: { format: 'title' } }}</span>
        <span *ngIf="backButtonState.text">{{ backButtonState.text }}</span>
      </mbs-button>
    </div>
    <div class="col-4 text-center">
      <mbs-button [isCtrl]="true"
                  (click)="skip(finishPath.Computers)">
        {{ 'wizards:onboarding.buttons.skip_wizard' | i18next: { format: 'title' } }}
        <span *ngIf="!selectedView || selectedView === view.Computers || selectedView === view.HyperV"
              class="cursor-help fa fa-info-circle text-info"
              container=".mbs-GSW"
              placement="auto"
              [ngbTooltip]="'wizards:onboarding.tooltips:skipButton' | i18next"></span>
      </mbs-button>
    </div>
    <div class="col-4 text-right">
      <mbs-button *ngIf="selectedView && nextButtonState.visible"
                  [type]="'primary'"
                  class="pr-3"
                  [disabled]="!!nextButtonState.disable"
                  (click)="moveNext()">
        <span *ngIf="!nextButtonState.text">{{ 'wizards:onboarding.buttons.next' | i18next: { format: 'title' } }}</span>
        <span *ngIf="nextButtonState.text">{{ nextButtonState.text }}</span>
      </mbs-button>
    </div>
  </div>
</ng-template>
